/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useComponentsWithCategories } from "./use-components-with-categories";
import { useMemo } from "react";
import { getDefaultImpl } from "cms/components/components/component";


const useComponentConfig = (type) => {
    
    const componentTypes = useComponentsWithCategories();

    const componentConfig = componentTypes.find((config) => {
        return config.type === type;
    });
    const defaultImpl = useMemo(
        () => getDefaultImpl(type),
        [type]
    );
    if (componentConfig) {
        componentConfig.defaultImpl = defaultImpl;
    }

    return componentConfig;
};

export { useComponentConfig };
